export const CVData = {
  name: "Laurence Klein",
  address: "Kirrawee, NSW 2232",
  phone: "0414 955 871",
  email: "laurence.klein89@gmail.com",
  linkedIn: "https://www.linkedin.com/in/laurence-w-klein",
  portfolio: "laurenceklein.au",
  profession: "Digital Systems | Customer Experience | Process Improvement",

  professional_summary:
    "Hands-on digital systems and customer-focused operations professional with nearly four years of experience as the primary technical and digital operations point of contact in a live office environment. Experience includes improving enrolment, booking, reporting, and staff-facing administrative workflows; supporting Windows devices and cloud platforms; maintaining websites and digital content; and helping non-technical users through clear communication, documentation, and training. Built and maintained live systems used by staff, parents, and community members, with strengths in process improvement, stakeholder support, systems thinking, and end-to-end delivery in low-resource environments. Seeking opportunities across digital operations, customer experience, junior business analysis, product support, and customer-facing technology roles.",

  core_skills: [
    "Customer-Focused Workflow Improvement",
    "Process Improvement & Systems Thinking",
    "Stakeholder Communication & User Training",
    "Digital Platforms, Content Operations & Administrative Support",
    "End-to-End Ownership in Low-Resource Environments"
  ],

  technical_skills: [
    "Customer-Facing Systems: Enrolment flows, booking systems, staff and admin workflows, form design, reporting workflows, training and documentation.",
    "Platforms & Administration: Google Workspace, Microsoft 365, Firebase, TryBooking, WordPress, Squarespace.",
    "Web, Content & Communications: Website content updates, digital communications support, Canva, structured content creation, reusable templates and process documentation.",
    "Process & Data: Google Sheets, administrative data management, event logistics tracking, issue triage, workflow simplification, reporting support.",
    "Tools: Git/GitHub, JIRA bug logging, browser developer tools, Firebase console, PowerShell / terminal."
  ],

  professional_experience: [
    {
      title: "Independent Digital Systems & Customer Experience Projects",
      company: "KleinSoft",
      location: "Sutherland Shire, NSW",
      date: "Jan 2026 – Present",
      responsibilities: [
        "Maintain and improve a live cloud-hosted enrolment platform, triaging issues, reviewing logs, refining workflows, and communicating updates to stakeholders.",
        "Design and improve customer-facing and admin-facing digital workflows that reduce manual work and improve clarity for non-technical users.",
        "Provide independent technical and systems support for local users, including device setup, user data migration, software troubleshooting, and account access resolution.",
        "Support digital solution delivery from issue identification through to refinement, rollout, and user guidance."
      ],
      highlight: "Live platform support includes production issue triage, workflow refinement, and stakeholder communication in a small-business setting.",
    },
    {
      title: "IT Support & Digital Systems",
      company: "St Catherine Labouré Catholic Church",
      location: "Gymea, NSW",
      date: "Apr 2022 – Feb 2026",
      responsibilities: [
        "Acted as the primary technical and digital operations point of contact for staff and volunteers in a live office environment serving a broader 300+ member community.",
        "Translated operational problems into practical digital solutions across booking flows, forms, reporting tools, and staff workflows, improving efficiency and reducing repeat administrative work.",
        "Administered the TryBooking platform for major events, including system setup, communications, reporting, and booking issue resolution.",
        "Supported Windows devices, cloud accounts, printers, file access, connectivity issues, domain and DNS tasks, and website updates across WordPress and Squarespace.",
        "Built Google Sheets-based management tools to track logistics, dietary requirements, payment status, and other event operations data.",
        "Delivered one-to-one support, training, and handover guidance for non-technical staff, translating technical issues into clear plain English.",
        "Created stakeholder-facing digital communications and promotional materials using Canva to support events, notices, and community engagement."
      ],
      highlight: "Built and supported internal tools that reduced repetitive admin, including the Mass Slide Builder and the first Sacrament Enrolment System.",
    },
    {
      title: "Administrative Assistant (IT & Web Support)",
      company: "Our Lady of the Rosary Church",
      location: "Fairfield, NSW",
      date: "Jan 2020 – Aug 2020",
      responsibilities: [
        "Implemented and managed an online booking system to support operational continuity and improve administrative coordination.",
        "Updated and maintained website content via WordPress and supported digital communications activities.",
        "Used Canva to create graphics for social media and community-facing communications.",
        "Handled reception and enquiries, welcoming visitors and responding to requests in a professional and service-focused manner.",
        "Liaised with staff, leadership, volunteers, and community groups to support smooth day-to-day operations.",
        "Prepared and maintained a COVID-19 Safety Plan aligned with government requirements."
      ],
      highlight: "",
    },
  ],

  selected_projects: [
    {
      name: "Sacrament Enrolment System",
      details: "React / Firebase | Live system",
      responsibilities: [
        "Designed, built, deployed, and improved a parent-facing and admin-facing enrolment platform intended to reduce administrative burden and improve the registration process.",
        "Created structured workflows, role-based access, and administrative dashboards, then iterated the system based on user feedback and production issues."
      ]
    },
    {
      name: "Mass Slide Builder",
      details: "Python desktop tool | Live system",
      responsibilities: [
        "Built a desktop tool that automated recurring slide preparation, reducing repetitive manual work and improving workflow consistency.",
        "Created documentation and delivered training to support handover and ongoing staff use."
      ]
    }
  ],

  education: [
    {
      degree: "Certificate III in Information Technology | In Progress",
      institution: "TAFE NSW | Expected 2026",
      relevance: "Completed units include cybersecurity awareness, online threat identification, secure information handling, and workplace collaboration.",
    },
    {
      degree: "Bachelor of Computer Science and Technology | Selected coursework completed",
      institution: "University of Sydney",
      relevance: "Data Structures, Database Systems, Operating Systems, Intro IT Security, Programming Foundations.",
    },
    {
      degree: "Excel Essential Training (Microsoft 365)",
      institution: "LinkedIn Learning | 2024",
      relevance: "",
    },
    {
      degree: "Bachelor of Arts | Distinction",
      institution: "University of Notre Dame Australia",
      relevance: "",
    },
  ],

};